import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { InputNumber } from 'antd';
import { TWILLY_MAX_QUANTITY } from '../../twilly';

const Quantity = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.quantity)}:</FormLabel>
      <Controller
        name={`productList.${index}.quantity`}
        control={control}
        render={({ field }) => (
          <InputNumber
            {...field}
            className="w-full"
            min={1}
            max={TWILLY_MAX_QUANTITY}
            precision={0}
            inputMode="numeric"
            onChange={(value) =>
              field.onChange(
                Math.min(value ?? 1, TWILLY_MAX_QUANTITY),
              )
            }
          />
        )}
      />
    </div>
  );
};

export default Quantity;
